import ReactGA from "react-ga4";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
    if (!GA_ID || initialized) return;
    ReactGA.initialize(GA_ID);
    initialized = true;
}

export function trackPageView(path) {
    if (!GA_ID) return;
    ReactGA.send({ hitType: "pageview", page: path });
}

export function trackEvent(action, params = {}) {
    if (!GA_ID) return;
    ReactGA.event(action, params);
}